/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Toast_ErrorInputs */

const he_notifications_toast_error = /** @type {(inputs: Notifications_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שגיאה בשמירת ההתראה`)
};

const en_notifications_toast_error = /** @type {(inputs: Notifications_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save notification`)
};

/**
* | output |
* | --- |
* | "Failed to save notification" |
*
* @param {Notifications_Toast_ErrorInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_toast_error = /** @type {((inputs?: Notifications_Toast_ErrorInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Toast_ErrorInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_toast_error(inputs)
	return en_notifications_toast_error(inputs)
});